<template>
  <el-dialog v-model="store.showLogin" width="360px" :before-close="handleClose" :close-on-click-modal="false">
    <el-form ref="userFormRef" :model="userForm" :rules="rules" label-width="0px">
      <el-form-item label="" prop="username">
        <el-input v-model="userForm.username" type="text" size="large" placeholder="账号">
          <template #suffix>
            <i class="fa fa-user fa-fw"></i>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item label="" prop="passwd">
        <el-input
          v-model="userForm.passwd"
          type="password"
          size="large"
          placeholder="密码"
          @keydown.enter.stop.native="handleSubmit(userFormRef)"
        >
          <template #suffix>
            <i class="fa fa-key fa-fw"></i>
          </template>
        </el-input>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button size="large" class="main-btn" @click="handleClose">取消</el-button>
      <el-button size="large" type="primary" class="main-btn" @click="handleSubmit(userFormRef)">登录</el-button>
    </div>
  </el-dialog>
</template>
<script setup>
  import { ref, reactive } from 'vue';
  import { ElMessage } from 'element-plus';
  import userApi from '@/api/user';
  import { useUserStore } from '@/stores/user';
  const store = useUserStore();

  const userFormRef = ref();
  const rules = reactive({
    username: { required: true, message: '请输入账号', trigger: 'blur' },
    passwd: [
      { required: true, message: '请输入密码', trigger: 'blur' },
      { min: 3, max: 16, message: '密码长度3~16位', trigger: 'blur' }
    ]
  });

  const userForm = reactive({
    username: '',
    passwd: ''
  });

  /**
   * 点击关闭登录对话框
   */
  const handleClose = () => {
    store.showLogin = false;
  };

  /**
   * 点击[登录]提交
   */
  const handleSubmit = async formEl => {
    if (!formEl) return;
    try {
      await formEl.validate();
    } catch (e) {
      return;
    }
    const result = await userApi.login({
      username: userForm.username,
      passwd: userForm.passwd
    });
    if (result?.errcode === 0 && result?.data && result?.data?.sig) {
      // 登录成功处理
      store.sig = result.data.sig;
      store.sig_t = Date.now();
      store.showLogin = false;
      formEl.resetFields();
    } else {
      ElMessage.warning(result.errmsg);
    }
  };
</script>
<style scoped>
  .main-btn {
    padding: 15px 60px;
    font-size: 16px;
  }
</style>
